import Spinner from "shared/ui/spinner";
import Text from "shared/ui/typography/Text";

const OrderLoader: React.FC = () => {
  return (
    <Text className="gg-flex gg-flex-row gg-space-x-2">
      <Spinner className="gg-text-black" />{" "}
      <span>{"Momentje, we halen de order voor je op!"}</span>
    </Text>
  );
};

export default OrderLoader;
